module.exports = __webpack_public_path__ + "static/media/2007_Population_totalRate.4441f7b7.png";